// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__wyA2k","footerText":"footer_footerText__S6Mrs"};